// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Separator, Button } from '../../../commons/atoms';
import { getLocationIcons } from './location-icons';

export function PaynetLocations(): Node {
  return (
    <>
      <PaymentLocationsWrapper>
        <Separator direction="vertical" size={2} />
        <PaymentLocationText />
        <PaymentLocationIcons />
        <DiscoverLocationButton />
      </PaymentLocationsWrapper>
    </>
  );
}

function PaymentLocationText(): Node {
  return (
    <PaymentLocationTextWrapper>
      <h1>Puntos de Pago</h1>
      <p>Preste este cupon en cualquier tienda afiliada de Paynet:</p>
    </PaymentLocationTextWrapper>
  );
}

function PaymentLocationIcons(): Node {
  const locationIcons = getLocationIcons();

  return (
    <IconsWrapper>
      {locationIcons.map((element, index)=>{
        return(
          <IconContainer key={index}>
            <LocationIcon key={index} src={element.imgSrc} alt={element.altText}></LocationIcon>
          </IconContainer>
        );
      })}
    </IconsWrapper>
  );
}

function DiscoverLocationButton(): Node {
  return (
    <DiscoverButton
      type="link"
      as="a"
      target="blank"
      href={'https://s3.amazonaws.com/public.openpay.mx/mapa-tiendas/index.html'}
      flat
      outline
      outlineColor="#2397d4"
    >Ver punto de pago más cercano
    </DiscoverButton>);
}


const DiscoverButton = styled(Button)`
  color: #2397d4;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  margin: 10px 50px;
  border-radius: 5px;
  display: block;
`;


const IconContainer = styled.div`
  width: 30%;
  display: inline-block;
  margin: 5px;
`;

const LocationIcon = styled.img`
  width: 100%;
  border: 1px solid #d7d7d7;
  border-radius: 3px;
`;

const IconsWrapper = styled.div`
  margin: 1em 5em;
`;

const PaymentLocationsWrapper = styled.div`
  margin: 10px;
  border-radius: 5px;
  border: 1px solid #c2c2c2;
`;

const PaymentLocationTextWrapper = styled.div`
  text-align: center;
  color: #666666;
`;
